import {fetchReceiveOverview} from "../network/ReceiveNetworkAPI";

export const ReceiveOverViewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_OVERVIEW":
            const {filter, capability, dispatcher, isCPTFilterEnabled} = action.data;
            fetchReceiveOverview(filter, capability, dispatcher, isCPTFilterEnabled)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "RECEIVE_STOW_DATA":
            return {...state, ...action.data}
        case "RECEIVE_PLANNED_DATA":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveOverViewReducer.js